import React from 'react'
import { Grid, Typography } from '@mui/material'
import { connect } from 'react-redux'
import SpalshImage from '../../assets/images/splash_image.png'
import IntlMessages from '../../util/IntlMessages'
import config from '../../util/config'
import useStyles from './styles'
import Br from '../br'

function Header(props) {
    const classes = useStyles()

    return (
        <React.Fragment>
            <Grid className={classes.root}>
                <Grid className={classes.gridImage}>
                    <img
                        src={SpalshImage}
                        alt={"dobande"}
                        className={classes.image} />
                </Grid>
                <Grid className={classes.gridVersion}>
                    <Typography variant="h1">
                        <IntlMessages id="dobande" />
                    </Typography>
                    <Br margin={10} />
                    <Typography variant="h6">
                        <IntlMessages id="version" /> {' '} {config.version}
                    </Typography>
                    <Br margin={10} />
                    <Typography variant="body1">
                        <IntlMessages id="privacy" />
                    </Typography>
                </Grid>
            </Grid>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)
